<div class="az-content">
  <div class="container">
    <app-medical-sources-filter [categories]="resultLimits.categoryBuckets" [platformTypes]="resultLimits.platformTypesBuckets"></app-medical-sources-filter>
    <div class="az-content-body pd-lg-l-40 d-flex flex-column">
      <div class="az-content-breadcrumb">
        <span>Medical Sources</span>
      </div>

      <div class="alert alert-info" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
        <strong>Work-in-Progress!</strong> Some sources may not be implemented correctly.
        Some sources may require frequent re-connection, as background refresh has not been implemented yet.
        <br/>
        If you have feedback regarding healthcare sources, please <a href="https://github.com/fastenhealth/fasten-onprem/issues" externalLink>file a ticket <i class="fab fa-github"></i></a>

        <span *ngIf="environment_name == 'sandbox'">
          <br/>
          <br/>
        In <strong>Sandbox mode</strong> Fasten Health cannot access real patient information. You must use Sandbox credentials when authenticating to healthcare sources.
          <a href="https://docs.fastenhealth.com/getting-started/sandbox.html#connecting-a-new-source" externalLink>These credentials are available in our Sandbox Guide</a>
        </span>
      </div>

      <app-medical-sources-connected></app-medical-sources-connected>


      <h2 class="az-content-title mg-t-40">Medical Record Sources</h2>

      <div class="az-content-label mg-b-5">Manual Upload</div>
      <p class="mg-b-20">Fasten also supports manually uploaded electronic medical records (EMR/EHR). Click below to upload.</p>

      <div class="row row-sm">
        <div class="col-lg">
          <ngx-dropzone [multiple]="false" (change)="uploadSourceBundleHandler($event)" accept=".json,.phr,.ndjson,.jsonl,.xml,.ccda,.cda">
            <ngx-dropzone-label>Select your EMR/EHR bundle. Must be in JSON or XML format</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of uploadedFile" [removable]="false">
              <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-preview>
          </ngx-dropzone>

          <div *ngIf="uploadErrorMsg" class="alert alert-danger mt-3" role="alert">
            <strong>Error:</strong> {{uploadErrorMsg}}
          </div>
        </div><!-- col -->
      </div><!-- row -->

      <hr class="mg-y-30">

      <div class="az-content-label mg-b-5">Healthcare Companies</div>
      <p class="mg-b-20">The following medical companies have API's which Fasten can use to retrieve your medical history.
        Please click the logos below to initiate the connection.</p>

      <!-- Search -->
      <div class="row row-sm sticky-top pt-2" style="position:sticky;">
        <div class="col-lg-8">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="search-prefix">Search</span>
            </div>
            <input [ngModel]="searchTermUpdate | async" (keyup)="searchTermUpdate.next($event.target.value)" type="text" class="form-control" placeholder="Search Term">
            <div class="input-group-append">
              <span class="input-group-text">{{this.availableLighthouseBrandList.length}} of {{this.resultLimits.totalItems}} results</span>
            </div>

          </div><!-- input-group -->
        </div><!-- col -->
      </div>


      <div *ngIf="!loading || availableLighthouseBrandList.length > 0 else isLoadingTemplate" class="row row-sm"
           infiniteScroll
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="50"
           (scrolled)="onScroll()"
      >

        <app-medical-sources-card class="col-sm-3 mg-b-20 px-3"

          *ngFor="let lighthouseBrand of availableLighthouseBrandList"
          [sourceInfo]="lighthouseBrand"
          [status]="status[lighthouseBrand.brand.id]"
          (onClick)="connectModalHandler(contentModalRef, $event)"
        ></app-medical-sources-card>

        <div *ngIf="availableLighthouseBrandList.length == 0" class="mg-b-60 w-100">
          <div class="card card-body bg-gray-200 bd-0">
            <p class="card-text">
              <strong>No results</strong> Try another search term or <a (click)="showRequestHealthSystemModal()" class="link">request this health system</a>.
            </p>
          </div>
        </div>

      </div><!-- row -->

      <div class="ht-40"></div>

    </div><!-- az-content-body -->
  </div><!-- container -->
</div><!-- az-content -->


<ng-template #contentModalRef let-modal>

  <div class="modal-header">
    <div class="media">
      <img class="modal-header-media-image mg-sm-r-20 mg-b-20 mg-sm-b-0" [src]="'assets/sources/'+(modalSelectedBrandListItem?.id +'.png')" [alt]="modalSelectedBrandListItem?.name">
      <div class="media-body">
        <h6>{{modalSelectedBrandListItem?.name}}</h6>
        <a *ngIf="modalSelectedBrandListItem?.brand_website"
           [href]="modalSelectedBrandListItem?.brand_website"
           class="mg-b-0" externalLink>{{modalSelectedBrandListItem?.brand_website | shortDomain}}</a>
      </div><!-- media-body -->
    </div><!-- media -->
    <button type="button" class="btn close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <h6>Connect Source</h6>
    <p>Would you like to connect this healthcare institution with Fasten Health? You will be redirected to their patient portal,
      where you can authenticate and select data to import into Fasten Health.
    </p>
    <div class="alert alert-warning">
      Patients must safeguard their health information, as HIPAA doesn't cover individual handling or most personal apps
    </div>
    <p>
      If the data about this institution is missing or incorrect, you can <a class="link" href="https://toolbox.fastenhealth.com/" externalLink>click here</a> to submit a correction.
    </p>


    <div *ngFor="let portal of modalSelectedBrandListItem?.portals" class="list-group">
      <ng-container *ngFor="let endpoint of portal?.endpoints">
        <div (click)="connectHandler($event, modalSelectedBrandListItem.id, portal.id, endpoint.id)" class="list-group-item list-group-item-action flex-column align-items-start cursor-pointer">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <h5 class="mb-1">
              <span *ngIf="status[endpoint.id] == 'authorize'" class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
              {{portal.name}}
            </h5>
            <span class="badge badge-primary badge-pill">{{endpoint.platform_type}}</span>
          </div>
          <p class="mb-1">{{portal.description}}</p>
          <small>{{portal.portal_website | shortDomain}}</small>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>


<ng-template #ccdaWarningModalRef let-modal>

  <div class="modal-header">
    <h6 class="modal-title">Convert your records?</h6>
    <button type="button" class="btn close" aria-label="Close" (click)="modal.dismiss('cancel')">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body">
    <h6>Fasten does not natively support <a href="https://en.wikipedia.org/wiki/Consolidated_Clinical_Document_Architecture"  externalLink >CCDA</a> Health Records</h6>

    <p>However we can convert it automatically using <a href="https://github.com/metriport/metriport/tree/master/packages/fhir-converter" externalLink>open-source software</a> generously provided the team at <a href="https://www.metriport.com/"  externalLink>Metriport</a><br/><br/>
      This converter is hosted by <a href="https://www.fastenhealth.com/" externalLink>Fasten Health, Inc.</a> and is subject to our <a href="https://policy.fastenhealth.com/privacy_policy.html" externalLink>Privacy Policy</a>.
      Your data will <strong>NEVER</strong> be shared with any third parties.
    </p>

    <div class="d-flex h-100">
      <div class="mx-auto my-auto">
        <a href="https://www.metriport.com/"  externalLink>
          <img style="height:50px" src="assets/images/metriport-logo.png">
        </a>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button (click)="modal.close('convert')" type="button" class="btn btn-indigo">Convert</button>
    <button (click)="modal.dismiss('cancel')" type="button" class="btn btn-outline-light">Cancel</button>
  </div>

</ng-template>


<ng-template #isLoadingTemplate>
  <div class="row">
    <div class="col-12">
      <app-loading-spinner [loadingTitle]="'Please wait, loading sources...'"></app-loading-spinner>
    </div>
  </div>
</ng-template>
